import { useMutation, useQueryClient } from '@tanstack/react-query';
import { CreateNewsPostV1, GK } from 'ck-queries';
import { createFormData, fetchWithErrorThrowing } from 'ck-utils';

import toast from 'react-hot-toast';

export const useNewsEdit = (id: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreateNewsPostV1) =>
      toast.promise(putEditNews(id, data), {
        loading: 'Laddar...',
        success: 'Nyheten har uppdaterats',
        error: 'Kunde inte uppdatera nyheten',
      }),
    onSuccess: () => {
      queryClient.invalidateQueries(GK.news);
    },
  });
};

async function putEditNews(id: string, data: CreateNewsPostV1) {
  const formData = createFormData(data);

  return fetchWithErrorThrowing(`/news-posts/${id}`, {
    method: 'PUT',
    body: formData,
  });
}
